/**
 * @generated SignedSource<<fc98f77cbd2f8bc638d8afaa701a2148>>
 * @relayHash f42bd1f59fd005be8ed14ca0e0e0aba1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d48cbc22de07f0f199074e0b68e12a25defe6e604fc71e6506cd3bed96cad206

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogMetaAPIConsumerWrapperQuery } from './BacklogMetaAPIConsumerWrapperQuery.graphql';

const node: PreloadableConcreteRequest<BacklogMetaAPIConsumerWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d48cbc22de07f0f199074e0b68e12a25defe6e604fc71e6506cd3bed96cad206",
    "metadata": {
      "connection": [
        {
          "count": "pageSize",
          "cursor": null,
          "direction": "forward"
        }
      ]
    },
    "name": "BacklogMetaAPIConsumerWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
